// @ts-nocheck
import Sheet from 'atoms/sheet/sheet';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import * as tableColumnSagaActions from 'models/tableColumns/sagaActions';
import * as tableColumnSelectors from 'models/tableColumns/selector';
import SideCar from 'molecules/sidecar/sidecar';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import CustomizeViewModal from 'organisms/CustomizeViewModal';
import ThetaMenu from 'organisms/thetaMenu/thetaMenu';
import UploadData from 'organisms/uploadData';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import * as constants from './constants';
import Breadcrumbs from 'atoms/breadcrumbs/breadcrumbs';
import ThetaDeleteModal from 'organisms/deleteModal/deleteModal';
import ExportGrid from 'organisms/exportGrid';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { isMasterDataSkusDelete, isMasterDataSkusWrite } from 'models/user/selector';
import GridActionBar from 'atoms/GridActionBar';
import GridCsvUpload from 'organisms/uploadData/gridCsvUpload';
import { isNewUploadEnabled } from 'models/user/selector';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { useColumnAliasName } from 'hooks/useColumnAliasName';
import { UPLOAD_MODEL_ID } from '../constants';
import { Button as AntButton, Tooltip } from 'antd';

const SKUMasterData: React.FunctionComponent = (props) => {
	const [openFilter, setOpenFilter] = React.useState<boolean>();
	const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);

	const tableId = constants.TABLE_ID.toString();
	const dispatch = useDispatch();
	const getColumnAliasName = useColumnAliasName(UPLOAD_MODEL_ID);

	const breadcrumbs = props.breadcrumbs?.map((res) => ({
		...res,
		name: getColumnAliasName(res.name),
	}));
	const [isDeleteModal, toggleDeleteModal] = React.useState(false);
	const hasWriteAccess = useSelector(isMasterDataSkusWrite);
	const hasDeleteAccess = useSelector(isMasterDataSkusDelete);
	const hasSearchFilters = useSelector((state) => dynamicGridSelectors.hasSearchFilters(state, constants.TABLE_ID));
	const gridMeta = useSelector((state) => dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID));

	const isCustomizeViewModalEnabled = useSelector((state) => tableColumnSelectors.isCustomizeViewModalEnabled(state));

	React.useEffect(() => {
		dispatch(dynamicGridSagaActions.erpEnabled({ tableId: constants.TABLE_ID }));
		dispatch(fetchBookmarksList({ tableId: constants.TABLE_ID }));
	}, [dispatch]);

	React.useEffect(() => {
		if (openFilter === undefined) {
			setOpenFilter(hasSearchFilters);
		}
	}, [hasSearchFilters]);

	const handleRefreshClick = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.refreshGridData({
				tableId: constants.TABLE_ID,
			})
		);
	}, [tableId, dispatch]);

	const handleResetTableColumns = React.useCallback(async () => {
		dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
	}, [dispatch, tableId]);

	const customizeViewHandler = React.useCallback((isCustomizeViewModalEnabled: boolean) => {
		dispatch(tableColumnSagaActions.setCustomizeViewModal(isCustomizeViewModalEnabled));
	}, []);

	const selectedSkus = useSelector((state) => dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID));

	const handleBulkDeleteClick = () => {
		dispatch(
			dynamicGridSagaActions.handleBulkRowDelete({
				tableId: constants.TABLE_ID,
			})
		);
		toggleDeleteModal(false);
	};

	const deleteItems = () => {
		toggleDeleteModal(true);
	};

	const getDisabledStatus = React.useCallback(
		(option: any) => {
			switch (option.value) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return false;
				case constants.MENU_ITEMS_VALUES.DELETE:
					return !selectedSkus?.selectedRowKeys?.length && !selectedSkus?.isSelectAll;
				default:
					return true;
			}
		},
		[selectedSkus]
	);

	const handleMenuItemClick = React.useCallback(
		(option: string) => {
			switch (option) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
					return customizeViewHandler(true);
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
					return handleResetTableColumns();
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return toggleUpload(true);
				case constants.MENU_ITEMS_VALUES.DELETE:
					return deleteItems();
				default:
					return;
			}
		},
		[handleResetTableColumns]
	);

	const hideCustomizeViewModal = React.useCallback(() => {
		customizeViewHandler(false);
	}, []);

	const uploadCloseClickHandler = React.useCallback(() => {
		toggleUpload(false);
	}, []);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		gridActions: hasDeleteAccess,
		enableMultiSort: true,
		selectionCallBack: () => {},
	};

	const templateConfig = {
		gridConfig,
		isFilterEnabled: openFilter === undefined ? false : openFilter,
		tableId: constants.TABLE_ID,

		dataProviderOptions: {
			type: 'POST',
			version: 2,
			...REQUESTS.POST.GET_GRID_DETAILS_V2,
			pathParams: { tableId: 18 },
		},
		selectRowKey: 'SKUID',
	};
	const isNewUpload = useSelector(isNewUploadEnabled);

	return (
		<React.Fragment>
			<Stack isVertical>
				<StackItem>
					<GridActionBar>
						<div className="content-head">
							<Stack gutter="medium" align="space-between">
								<div className="content-head-lt">
									<Breadcrumbs crumbs={breadcrumbs} />
								</div>
								<div className="content-head-rt">
									<Stack gutter="medium" className="action-btns">
										{isNewUpload && gridMeta?.UploadTableID && (
											<StackItem className="action-btn">
												<GridCsvUpload
													uploadTableId={gridMeta?.UploadTableID}
													parentTableId={tableId}
												/>
											</StackItem>
										)}
										<StackItem className="action-btn">
											<Tooltip title="Refresh">
												{' '}
												<AntButton
													className="menu-action--button"
													icon={
														<FontAwesomeIcon className="font-icon" icon={faArrowsRotate} />
													}
													onClick={handleRefreshClick}
												/>
											</Tooltip>
										</StackItem>
										<StackItem className="action-btn">
											<ExportGrid tableId={18} />
										</StackItem>
										<StackItem className="action-btn">
											<Tooltip title="More Options">
												{' '}
												<ThetaMenu
													type="3Dots"
													options={
														hasWriteAccess
															? constants.MENU_ITEMS
															: [constants.MENU_ITEMS[0]]
													}
													handleItemClick={handleMenuItemClick}
													isDisabled={getDisabledStatus}
												/>
											</Tooltip>
										</StackItem>
									</Stack>
								</div>
							</Stack>
						</div>
					</GridActionBar>
				</StackItem>
				<StackItem isStretch isGrow>
					<Sheet isPage className="order-tbl">
						<Stack isVertical gutter="medium">
							<StackItem isGrow isStretch>
								<ThetaGridPaginated config={templateConfig} />
							</StackItem>
						</Stack>
					</Sheet>
				</StackItem>
			</Stack>

			{isCustomizeViewModalEnabled && (
				<CustomizeViewModal hideModal={hideCustomizeViewModal} tableId={constants.TABLE_ID} />
			)}
			{isUploadEnabled && (
				<SideCar isActive={isUploadEnabled} handleOnClose={uploadCloseClickHandler}>
					<UploadData tableId={tableId} />
				</SideCar>
			)}
			{isDeleteModal && (
				<ThetaDeleteModal
					hideModal={() => {
						toggleDeleteModal(false);
					}}
					modalTitle={`SKU's`}
					title={`(${
						selectedSkus?.isSelectAll ? 'All' : selectedSkus?.selectedRowKeys.length
					}) selected SKUs(s)`}
					handleDeleteClick={handleBulkDeleteClick}
					isLocked={true}
				/>
			)}
		</React.Fragment>
	);
};
export default SKUMasterData;
